module.exports = __webpack_public_path__ + "img/service-pickerluberprufung.0362860f.jpg";